import React from 'react';
import { Calendar } from 'lucide-react';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Checkbox } from '../ui/checkbox';
import { TIME_PERIODS, CONTACT_METHODS } from '../inquiry/constants';

export const InquiryStep3 = ({ errors, formData, handleChange }) => (
    <div className="space-y-4">
      <div className="text-center mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-3">
          <Calendar className="w-6 h-6 text-white" />
        </div>
        <h3 className="font-semibold text-lg">Preferences & Timeline</h3>
        <p className="text-sm text-gray-500">How should we reach you?</p>
      </div>

      <div className="space-y-4">
        <div>
          <Label className="mb-2 block">Preferred Contact Method</Label>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
            {CONTACT_METHODS.map(method => {
              const Icon = method.icon;
              return (
                <div
                  key={method.value}
                  onClick={() => handleChange('preferred_contact', method.value)}
                  className={`flex flex-col items-center gap-1 p-3 rounded-lg border cursor-pointer transition-all ${
                    formData.preferred_contact === method.value
                      ? 'border-orange-500 bg-orange-50 text-orange-700'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                >
                  <Icon className="w-5 h-5" />
                  <span className="text-xs">{method.label}</span>
                </div>
              );
            })}
          </div>
        </div>

        <div>
          <Label htmlFor="preferred_time">When do you plan to travel? *</Label>
          <Select value={formData.preferred_time} onValueChange={(v) => handleChange('preferred_time', v)}>
            <SelectTrigger className={errors.preferred_time ? 'border-red-500' : ''} data-testid="inquiry-time">
              <SelectValue placeholder="Select time period" />
            </SelectTrigger>
            <SelectContent>
              {TIME_PERIODS.map(t => (
                <SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          {errors.preferred_time && <p className="text-xs text-red-500 mt-1">{errors.preferred_time}</p>}
        </div>

        <div>
          <Label htmlFor="additional_notes">Additional Notes (Optional)</Label>
          <Textarea
            id="additional_notes"
            placeholder="Any specific questions or requirements..."
            value={formData.additional_notes}
            onChange={(e) => handleChange('additional_notes', e.target.value)}
            className="min-h-[60px]"
            data-testid="inquiry-notes"
          />
        </div>

        <div className={`flex items-start gap-2 p-3 rounded-lg border ${errors.consent ? 'border-red-500 bg-red-50' : 'border-gray-200 bg-gray-50'}`}>
          <Checkbox
            id="consent"
            checked={formData.consent}
            onCheckedChange={(checked) => handleChange('consent', checked)}
            data-testid="inquiry-consent"
          />
          <label htmlFor="consent" className="text-xs text-gray-600 cursor-pointer">
            I agree to receive communications about my medical inquiry and accept the{' '}
            <a href="/privacy-policy" className="text-orange-600 hover:underline">Privacy Policy</a> and{' '}
            <a href="/terms" className="text-orange-600 hover:underline">Terms of Service</a>.
          </label>
        </div>
        {errors.consent && <p className="text-xs text-red-500">{errors.consent}</p>}
      </div>
    </div>
);
